module.exports = __webpack_public_path__ + "static/og-image-228d6c0adf9a65018718d767da05f893.png";